module.exports = __webpack_public_path__ + "img/hopways.b48238a5.jpeg";